export const youtube_box = function() {
    document.getElementById('app').arrive(".youtube", function() {

        var classes = ['wp-block-embed-youtube', 'aligncenter', 'wp-block-embed', 'is-type-video', 'is-provider-youtube', 'wp-embed-aspect-16-9', 'wp-has-aspect-ratio'];
        var yt_id = this.getAttribute('id');
        var captiontxt = this.innerText;

        var iframe = document.createElement('iframe');
        iframe.setAttribute('width', '500');
        iframe.setAttribute('height', '375');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + yt_id + '?feature=oembed');
        
        var caption = document.createElement('figcaption');
        caption.innerHTML = captiontxt;

        var inner = document.createElement('div');
        inner.classList.add('wp-block-embed__wrapper');

        inner.appendChild(iframe);

        var figure = document.createElement('figure');
        for (var class_to_add of classes) {
            figure.classList.add(class_to_add);
        }

        figure.appendChild(inner);
        figure.appendChild(caption);
     
        this.appendChild(figure);
    });
}